import { makeAutoObservable } from "mobx"
import { QDataTypes } from "./index.d"
// import { makePersistable } from "mobx-persist-store"

const Params = new URL(window.location.href).searchParams
const Href = window.location.href
/**
 * AppStore.device -
 * Mobile: 0, Desktop: 1
 */

class AppStore {
  appLoaded: boolean = false
  device: 0 | 1 = 0
  footerVisiblity: boolean = false
  isDepTesting: boolean = Href.includes("depTesting")
  isLocalHost: boolean = window.location.hostname === "localhost"
  isPrerendering: boolean = Params.get("isPrerendering") === "yes"
  ipAddress: string = ""
  windowWidth: any = window.innerWidth
  isPreprod:boolean = Href.includes("appform=prod")
  isTesting: boolean = Href.includes("testing")
  isResumeJourney: boolean = Params.get("applicationState") === "resume"
  appFormLoaded: boolean = false // State Updates Only Once To Keep AppForm Mounted Once Its Loaded
  isQDataGlobalMasked: boolean = false // Useful when redirecting DIGI Based QData to Different Product Lines
  isQDataMasked: QDataTypes = {
    parentDOB: false,
    childDOB: false
  }
  dataSource: "qdata" | "" = ""

  constructor() {
    makeAutoObservable(this)
    // makePersistable(this, {
    //   name: "device",
    //   properties: ["device"],
    //   storage: window.localStorage,
    // })
  }
  setWindowWidth = (data: any) => (this.windowWidth = data)

  setAppLoaded = (data: boolean) => (this.appLoaded = data)
  setDevice = (data: 0 | 1) => (this.device = data)
  setFooterVisiblity = (data: boolean) => (this.footerVisiblity = data)
  setLocalHost = (data: boolean) => (this.isLocalHost = data)
  setIpAddress = (data: string) => (this.ipAddress = data)
  setIsTesting = (data: boolean) => (this.isTesting = data)
  setIsResumeJourney = (data: boolean) => (this.isResumeJourney = data)
  setAppFormLoaded = (data: boolean) => (this.appFormLoaded = data)
  setIsQDataMasked = (data: QDataTypes) => (this.isQDataMasked = data)
  setIsQDataGlobalMasked = (data: boolean) => (this.isQDataGlobalMasked = data)
  setDataSource = (data: "qdata" | "") => (this.dataSource = data)
}

export default new AppStore()
